<template>
<!-- 水电表 -->
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>水电表管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>设备序列号：</span>
                <el-input placeholder="请输入序列号" v-model="search.imei"></el-input>
                <span>设备类型：</span>
                <el-select v-model="search.type" clearable @change="doFilter">
                  <el-option label="水表" value="1"></el-option>
                  <el-option label="电表" value="2"></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()" style="margin-left:2vw;">绑定水电表</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" height="100%">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备序列号">
                    <template slot-scope="scope">
                      <span>{{ scope.row.imei}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.type=='1'">水表</span>
                      <span v-else-if="scope.row.type=='2'">电表</span>
                      <span v-else></span>
                    </template>
                </el-table-column>
                <el-table-column label="所属项目">
                    <template slot-scope="scope">
                    <span>{{ scope.row.groupName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.createDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="120px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                      <el-form-item label="设备名称：" prop="name">
                          <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="设备序列号：" prop="imei">
                          <el-input v-model="addForm.imei" placeholder="请输入序列号" autocomplete="off">天门湖项目</el-input>
                      </el-form-item>
                      <el-form-item label="类型：" prop="type">
                          <el-select v-model="addForm.type">
                            <el-option label="水表" value="1"></el-option>
                            <el-option label="电表" value="2"></el-option>
                          </el-select>
                      </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="addFormVisible = false">取 消</el-button>
                      <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      search:{
        type:'',
        imei:''
      },
      // projectId: '',
      //typeNameAll: [
        // { status: '进闸', value: '0' },
        // { status: '出闸', value: '1' },
        // { status: '未配置', value: '2' },
        // { status: '采集机', value: '4' },
        // { status: '特种使用', value: '5' }
      //], // 类型下拉菜单组
      //status: '进闸', // 类型下拉菜单默认值
      // millNameAll: [
      //   { machType: '零视', value: '1' },
      //   { machType: '汉王', value: '2' },
      //   { machType: '宇泛', value: '3' }
      // ], // 厂家下拉菜单组
      // machType: '零视', // 厂家下拉菜单默认值
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {   // 添加设备表单数组
        name:'',
        imei:'',
        type:'',
        groupId:'',
        createBy:''
      }, 
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      rules: {
        name: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        imei: [
          { required: true, message: '请输入设备序列号', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.addForm.groupId = this.groupId
    this.getData()
    //this.getList()
    //this.getDict()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    doFilter(){
      this.currentPage = 1
      this.getData()
    },

    // 获取数据
    getData() {
      var that = this
      myHttp.selectWaterElectricityListPage({
        type:this.search.type,
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        groupId:this.groupId,
        imei:this.search.imei
      }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.PageInfo.list||[]
            for(var i=0;i<list.length;i++){
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.PageInfo.total||0
            if(list.length==0){
              that.dataText = '暂无数据'
            }
          }else{
            that.dataText = '暂无数据'
          }
      },function() {
        that.dataText = '暂无数据'
      })
    },

    //获取列表
    // getList() {
    //   var option = {
    //     projectId: this.groupId
    //   }
    //   var that = this
    //   myHttp.getMachineList(option).then(
    //     function(resp) {
    //       //var projectName = "";
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.pageInfo || []
    //         for (var i = 0; i < list.length; i++) {
    //           //that.projectName = list[i].projectName;
    //           list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
    //           list[i].statusName = that.filterSatus(list[i].status)
    //         }
    //         that.tableDataEnd = list
    //         if (that.tableDataEnd.length == 0) {
    //           that.dataText = '暂无数据'
    //         }
    //       } else {
    //         that.$message.error(resp.data.msg)
    //         that.dataText = '暂无数据'
    //       }
    //     },
    //     function() {}
    //   )
    // },

    //获取类型
    filterSatus(str){
      var list = this.typeNameAll
      var result = ''
      for(var i=0;i<list.length;i++){
        if(str == list[i].value){
          result = list[i].label
        }
      }
      return result
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      this.addForm.name = row.name
      this.addForm.imei = row.imei
      this.addForm.type = row.type
      this.addForm.id = row.id
      this.addForm.updateBy = util.session.get('user').id
    },

    // 删除数据 111
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp
          .deleteWaterElectricity({
            id: row.id,
            updateBy:util.session.get('user').id
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '考勤机绑定'
      this.addFormVisible = true
      this.addForm.name = ''
      this.addForm.imei = ''
      this.addForm.type = ''
      this.addForm.id = ''
      this.addForm.createBy = util.session.get('user').id
      
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      // console.log(that.addForm)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            // if (that.addForm.password == '') {
            //   that.$message.error('创建时请输入密码！')
            //   return
            // }
            // that.addForm.id = that.addForm.imei
            //添加
            myHttp.postWaterElectricity(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.currentPage = 1
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改 1111
            myHttp.updateWaterElectricity(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    // 字典接口
    // getPageList
    // getDict() {
    //   var that = this
    //   myHttp.getDictByType({
    //       type: 'attend_type'
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         that.typeNameAll = resp.data.data.dictList
    //         that.getList()
    //       } else {
    //         that.$message.error(resp.data.msg)
    //       }
    //     })
    // }
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 14vh );
        /* margin: 0 auto; */
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>
<style>
@import '../../../assets/css/common.css';
</style>